import type { StoreId } from "@KassaroAB/shared/types/ids";
import type { RestGetStaff } from "@KassaroAB/shared/types/Staff";
import { api } from "../utils/api";

export const getStaffApi = async (storeId: StoreId): Promise<RestGetStaff[]> => {
  return api.get(`stores/${storeId}/staff`);
};
